import { GetFonts } from '@/connection/font-packs';
import { FetchError } from '@/connection/helpers';
import { TemplatesReducerCreator } from '../types';

const fetchFontPacksReducer = (create: TemplatesReducerCreator) => {
  return create.asyncThunk(
    async ({ channel }: { channel: number }, { rejectWithValue }) => {
      try {
        const fonts = await GetFonts(channel);
        return fonts;
      } catch (e) {
        if (e instanceof FetchError) {
          return rejectWithValue(e.message);
        }

        throw e;
      }
    },
    {
      fulfilled: (state, action) => {
        state.fontPacks = action.payload;
      },
      pending: (state) => {
        state.loadingFontPacks = true;
      },
      rejected: (_, action) => {
        console.error(action.error);
      },
      settled: (state) => {
        state.loadingFontPacks = false;
      },
    }
  );
};

export default fetchFontPacksReducer;
